import { render, staticRenderFns } from "./regulation2.vue?vue&type=template&id=4a0fb0bf&scoped=true"
import script from "./regulation2.vue?vue&type=script&lang=js"
export * from "./regulation2.vue?vue&type=script&lang=js"
import style0 from "./regulation2.vue?vue&type=style&index=0&id=4a0fb0bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0fb0bf",
  null
  
)

export default component.exports